import { render, staticRenderFns } from "./RegionSelect.vue?vue&type=template&id=ee708bb6&scoped=true&"
import script from "./RegionSelect.vue?vue&type=script&lang=ts&"
export * from "./RegionSelect.vue?vue&type=script&lang=ts&"
import style0 from "./RegionSelect.vue?vue&type=style&index=0&id=ee708bb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee708bb6",
  null
  
)

export default component.exports